/**
 * Union of two map-household lists by id, for a viewport refetch made with the SAME
 * filters as what is already on the map.
 *
 * Why: the map refetches as the user zooms out or pans, and used to REPLACE its list with
 * the new box's result. Any difference — even 1–3 far-away outliers dropping out of a
 * narrower box — made the marker layer tear down and rebuild every marker, which on a
 * 2,700-contact account froze the page for seconds per zoom (owner, 2026-10-08). Keeping
 * what is already loaded means a refetch only ever ADDS markers.
 *
 * Rows in `next` win (fresher data for the same household); order is `prev` first, then
 * households new in `next`.
 */
export function mergeMapHouseholds<T extends { id: number }>(prev: T[] | null | undefined, next: T[] | null | undefined): T[] {
  if (!prev || prev.length === 0) return next ? [...next] : [];
  if (!next || next.length === 0) return [...prev];

  const nextById = new Map(next.map((h) => [h.id, h]));
  const merged = prev.map((h) => nextById.get(h.id) ?? h);
  const seen = new Set(prev.map((h) => h.id));
  for (const h of next) {
    if (!seen.has(h.id)) merged.push(h);
  }
  return merged;
}
